export default "__VITE_ASSET__DUx8eJ7U__"